import Vue from 'vue';
import DialogPlugin from '@/app/core/plugins/dialog';

Vue.use(DialogPlugin);
